module.exports = __webpack_public_path__ + "static/media/sec1logo1.7ca07752.svg";